<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">Thêm mới thông báo</span>
        <span v-if="mData.viewMode == 'update'">Cập nhật thông báo</span>
        <span v-if="mData.viewMode == 'detail'">Chi tiết thông báo</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="9">
              <el-form-item label="Tiêu đề" prop="title">
                <el-input
                  type="text"
                  v-model="mData.dataForm.title"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Thời điểm hết hạn" prop="expiredTime">
                <el-date-picker
                  v-if="!haveExpiredTime"
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.expiredTime"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                  :picker-options="pickerOptions"
                ></el-date-picker>
                <el-input
                  v-if="haveExpiredTime"
                  type="text"
                  v-model="mData.dataForm.expiredTime"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung thông báo" prop="intro">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.intro"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  :rows="3"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item label="Link" prop="link">
                <el-input
                  type="text"
                  v-model="mData.dataForm.link"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col
              md="4"
              v-show="
                this.mData.dataDefault.showTour &&
                this.mData.viewMode != 'detail'
              "
            >
              <el-form-item label="Gửi theo" prop="targetType">
                <el-select
                  v-model="mData.dataForm.targetType"
                  placeholder="Chọn"
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_changeTargetType(mData.dataForm.targetType)"
                  clearable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listTargetType"
                    :key="item.type"
                    :label="item.title"
                    :value="item.type"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col
              md="4"
              v-show="
                (mData.dataForm.targetType &&
                  mData.dataDefault.showTour &&
                  this.mData.viewMode != 'detail') ||
                !mData.dataDefault.showTour
              "
            >
              <el-form-item label="Loại thông báo" prop="type">
                <el-select
                  v-model.trim="mData.dataForm.type"
                  placeholder="Chọn"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @change="fn_changeType(mData.dataForm.type)"
                  @input="forceUpdateUI"
                  v-if="
                    (mData.dataForm.targetType == 'people' &&
                      mData.dataDefault.showTour) ||
                    !mData.dataDefault.showTour
                  "
                >
                  <el-option
                    v-for="item in mData.dataDefault.typeNotifi"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model.trim="mData.dataForm.type"
                  placeholder="Chọn"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  @change="fn_changeType(mData.dataForm.type)"
                  @input="forceUpdateUI"
                  v-if="mData.dataForm.targetType == 'tour'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.typeNotifiByTour"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Ngôn ngữ" prop="language">
                <el-select
                  v-model="mData.dataForm.language"
                  placeholder="Chọn"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNgoaiNgu"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              v-show="mData.viewMode != 'detail'"
              v-if="mData.dataForm.targetType == 'tour' && mData.dataForm.type"
            >
              <el-form-item label="Tour">
                <el-autocomplete
                  clearable
                  class="inline-input"
                  v-model="mData.dataDefault.itemTour"
                  :fetch-suggestions="querySearchListTour"
                  placeholder="Nhập từ khóa để tìm kiếm"
                  :trigger-on-focus="false"
                  @select="handleSelectListTour"
                  @change="handleSelectListTour"
                >
                  <template slot-scope="{ item }">
                    <span class="link">{{
                      item.ten_tour +
                      " - Đoàn: " +
                      (item.ten_doan ? item.ten_doan : "") +
                      " - Địa điểm: " +
                      (item.dia_diem ? item.dia_diem.dia_diem : "")
                    }}</span>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </b-col>
            <b-col
              md="6"
              v-show="mData.viewMode != 'detail'"
              v-if="
                mData.dataForm.type == 'MessageToTourist' &&
                mData.dataForm.targetType == 'people'
              "
            >
              <el-form-item label="Người nhận (khách du lịch)">
                <el-autocomplete
                  clearable
                  class="inline-input"
                  v-model="mData.dataDefault.itemKhachDuLich"
                  :fetch-suggestions="querySearchKhachDuLichST"
                  @keyup.enter.native="fn_enterFindKhachDuLich()"
                  placeholder="Tìm theo số thẻ"
                  :trigger-on-focus="false"
                  @select="handleSelectKhachDuLichST"
                >
                  <template slot-scope="{ item }">
                    <span class="link">{{
                      (item.ho_ten &&
                      item.ho_ten.ho_ten &&
                      item.ho_ten.ho_ten.trim() != ""
                        ? item.ho_ten.ho_ten
                        : "Chưa có thông tin") +
                      " - Email: " +
                      (item.email ? item.email : "Chưa có thông tin") +
                      " - SĐT: " +
                      (item.dien_thoai ? item.dien_thoai : "")
                    }}</span>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </b-col>
            <b-col
              md="6"
              v-show="mData.viewMode != 'detail'"
              v-if="
                mData.dataForm.type == 'MessageToTourGuide' &&
                mData.dataForm.targetType == 'people'
              "
            >
              <el-form-item label="Người nhận (hướng dẫn viên)">
                <el-autocomplete
                  clearable
                  class="inline-input"
                  v-model="mData.dataDefault.itemHuongDanVien"
                  :fetch-suggestions="querySearchHuongDanVienST"
                  placeholder="Tìm theo số thẻ"
                  :trigger-on-focus="false"
                  @select="handleSelectHuongDanVienST"
                >
                  <template slot-scope="{ item }">
                    <span class="link">{{
                      item.ho_ten &&
                      item.ho_ten.ho_ten +
                        " - Email: " +
                        (item.email ? item.email : "") +
                        " - SĐT: " +
                        (item.dien_thoai ? item.dien_thoai : "")
                    }}</span>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row
            class="mb-2"
            v-show="
              ((mData.viewMode == 'detail' &&
                mData.dataForm.type == 'MessageToTourist') ||
                mData.viewMode != 'detail') &&
              this.mData.dataDefault.showTour
            "
          >
            <b-col md="12" class="mb-2">Danh sách khách du lịch</b-col>
            <b-col md="12">
              <el-table
                :data="mData.dataDefault.ListKhachDuLichTable"
                border
                max-height="440"
                style="width: 100%; display: grid"
              >
                <el-table-column
                  prop="ho_ten.ho_ten"
                  label="Họ tên"
                  width="auto"
                  min-width="200"
                ></el-table-column>

                <!-- <el-table-column
                  prop="so_the"
                  label="Số thẻ"
                  width="150"
                  align="right"
                ></el-table-column> -->
                <el-table-column label="Số thẻ" width="150" align="right">
                  <template slot-scope="scope" v-if="scope.row">
                    {{
                      scope.row.so_the &&
                      scope.row.so_the.slice(0, 2) &&
                      scope.row.so_the.length == 11
                        ? "Chưa có thông tin"
                        : scope.row.so_the
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="email"
                  label="Email"
                  width="180"
                ></el-table-column>
                <!-- <el-table-column
                  prop="dien_thoai"
                  label="Điện thoại"
                  width="150"
                  align="right"
                ></el-table-column> -->
                <el-table-column label="Điện thoại" width="150" align="right">
                  <template slot-scope="scope" v-if="scope.row">
                    {{
                      scope.row.so_the &&
                      scope.row.so_the.slice(0, 2) &&
                      scope.row.so_the.length == 11
                        ? scope.row.so_the
                        : scope.row.dien_thoai
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="ngay_sinh.ngay_sinh"
                  label="Ngày sinh"
                  :formatter="fn_formatterDate"
                  width="120"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="quoc_tich.ten_quoc_tich"
                  label="Quốc tịch"
                  width="100"
                ></el-table-column>

                <el-table-column
                  label="Thao tác"
                  align="center"
                  width="100px"
                  v-if="mData.viewMode != 'detail'"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="fn_deleteKhachDuLich(scope.$index)"
                      v-b-popover.hover.left="'Xóa'"
                    >
                      <i class="icon-trash icons"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </b-col>
          </b-row>
          <b-row
            v-show="
              ((mData.viewMode == 'detail' &&
                mData.dataForm.type == 'MessageToTourGuide') ||
                mData.viewMode != 'detail') &&
              this.mData.dataDefault.showTour
            "
          >
            <b-col md="12" class="mb-2">Danh sách hướng dẫn viên</b-col>
            <b-col md="12">
              <el-table
                :data="mData.dataDefault.ListHuongDanVienTable"
                border
                max-height="440"
                style="width: 100%; display: grid"
              >
                <el-table-column
                  prop="ho_ten.ho_ten"
                  label="Họ tên"
                  width="auto"
                  min-width="200"
                ></el-table-column>

                <el-table-column
                  prop="the_hdv.so_the"
                  label="Số thẻ"
                  width="150"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="email"
                  label="Email"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="dien_thoai"
                  label="Điện thoại"
                  width="150"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="ngay_sinh.ngay_sinh"
                  label="Ngày sinh"
                  width="120"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="quoc_tich.ten_quoc_tich"
                  label="Quốc tịch"
                  width="100"
                ></el-table-column>

                <el-table-column
                  label="Thao tác"
                  align="center"
                  width="100px"
                  v-if="mData.viewMode != 'detail'"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="fn_deleteHuongDanVien(scope.$index)"
                      v-b-popover.hover.left="'Xóa'"
                    >
                      <i class="icon-trash icons"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
              >Thêm mới</el-button
            >

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
              >Cập nhật</el-button
            >

            <el-button @click="fn_go()" type="info" plain>Quay lại</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ThongBaoModel from "./ThongBaoModel";
import mushroomDulich from "../../../service/api/dulich-api";
import * as moment from "moment";

export default {
  data() {
    return {
      queryStringKDL: "",
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "ThongBao",
        dataDefault: {
          roles: DataService.rolesInForm,
          listNgoaiNgu: DataService.Languages,
          typeNotifi: [],
          typeNotifiByTour: [],
          CongTyLuHanh: {},

          ListKhachDuLich: [],
          textFindKhachDuLich: "",
          itemKhachDuLich: null,
          ListKhachDuLichTable: [],

          ListHuongDanVien: [],
          textFindHuongDanVien: "",
          itemHuongDanVien: null,
          ListHuongDanVienTable: [],

          ListTour: [],
          showTour: false,
          itemTour: null,
          ListTourTable: [],

          listTargetType: [
            { type: "people", title: "Theo tài khoản" },
            { type: "tour", title: "Theo tour" },
          ],

          validErrorTime: false,
        },
        dataForm: MethodService.copyObject(ThongBaoModel.dataForm),
        validForm: ThongBaoModel.validForm,
        dialog: {},
      },
      haveExpiredTime: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    async querySearchKhachDuLichST(queryString, cb) {
      queryString = queryString.trim();
      let resKhachDuLichApi =
        await mushroomDulich.user.getUserIdOrFetchAcsUserAsync({
          body: { cardCode: queryString },
        });
      if (resKhachDuLichApi.result && resKhachDuLichApi.result.length > 0) {
        let khachDuLichApiResult =
          await mushroomDulich.khach_du_lich.findByIdAsync({
            id: resKhachDuLichApi.result,
          });
        let listKhachDuLichApiResult = [khachDuLichApiResult.result];
        var results = queryString && listKhachDuLichApiResult;
      }
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectKhachDuLichST(item) {
      this.mData.dataDefault.itemKhachDuLich = item;
      this.fn_addKhachDuLich(this.mData.dataDefault.itemKhachDuLich);
    },

    async querySearchHuongDanVienST(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await mushroomDulich.huong_dan_vien.listAsync({
        filters: `the_hdv.trang_thai=true&the_hdv.so_the=${encodeURIComponent(
          queryString
        )}`,
      });
      // console.log('resHuongDanVienApi',resHuongDanVienApi);

      var results = queryString
        ? resHuongDanVienApi.result.filter((item) =>
            item.the_hdv.so_the.includes(queryString)
          )
        : resHuongDanVienApi.result;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelectHuongDanVienST(item) {
      this.mData.dataDefault.itemHuongDanVien = item;
      this.fn_addHuongDanVien(this.mData.dataDefault.itemHuongDanVien);
    },

    async querySearchListTour(queryString, cb) {
      queryString = queryString.trim();

      if (queryString && queryString.length > 0) {
        let query1 = queryString
          .replace("*", "\\*")
          .replace("$", "\\$")
          .replace("%", "\\*")
          .replace("[", "\\[")
          .replace("]", "\\]")
          .replace("^", "\\^");
        if (this.mData.dataDefault.CongTyLuHanh) {
          let resTourApi = await mushroomDulich.tour.listAsync({
            limit: 1000,
            filters: `ten_tour:regex_i:${query1}`,
          });
          this.mData.dataDefault.ListTour = resTourApi.result;
        } else {
          let resTourApi = await mushroomDulich.tour.listAsync({
            limit: 1000,
            filters: `ten_tour:regex_i:${query1}`,
          });
          this.mData.dataDefault.ListTour = resTourApi.result;
        }
      }
      var results = queryString && this.mData.dataDefault.ListTour;

      // console.log('resHuongDanVienApi',resHuongDanVienApi);

      // call callback function to return suggestions
      cb(results);
    },
    handleSelectListTour(item) {
      this.mData.dataDefault.itemTour = item;
      this.fn_addTour(this.mData.dataDefault.itemTour);
    },

    fn_submitForm(type) {
      if (this.mData.dataForm.title) {
        this.mData.dataForm.title = this.mData.dataForm.title.trim();
      }
      if (this.mData.dataForm.intro) {
        this.mData.dataForm.intro = this.mData.dataForm.intro.trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            this.mData.dataForm.createdTime = moment().format();
            let data = this.mData.dataForm;
            let dataLogs = MethodService.copyObject(this.mData.dataForm);
            console.log(
              "this.mData.dataDefault.showTour",
              this.mData.dataDefault.showTour
            );
            if (this.mData.dataDefault.showTour == false) {
              delete data.targetType;
              delete dataLogs.targetType;
              delete dataLogs.to;
              delete dataLogs.isRead;
              dataLogs["tos"] = [];
              dataLogs["tours"] = [];
              let currentUser = MethodService.getCurrentUser();
              data.to = currentUser.id;
              data.group_type = "Officer";
              window.toastr.success(
                "Hệ thống đang gửi thông báo. Vui lòng đợi trong giây lát!"
              );
              const res = await mushroomDulich.notification_log.createAsync(
                dataLogs
              );
              this.fn_resetForm();
              this.fn_go(-1);
            } else {
              delete data.targetType;
              delete dataLogs.targetType;
              delete dataLogs.to;
              delete dataLogs.isRead;
              let listTourist = [];
              let listTourguide = [];

              let logIdToTourist = undefined;
              let logIdToTourguide = undefined;
              if (
                (this.mData.dataDefault.ListKhachDuLichTable &&
                  this.mData.dataDefault.ListKhachDuLichTable.length == 0 &&
                  this.mData.dataDefault.ListHuongDanVienTable &&
                  this.mData.dataDefault.ListHuongDanVienTable.length == 0) ||
                (!this.mData.dataDefault.ListHuongDanVienTable &&
                  !this.mData.dataDefault.ListKhachDuLichTable)
              ) {
                window.toastr.warning(
                  "Bạn chưa thêm Hướng dẫn viên hoặc khách du lịch"
                );
                MethodService.stopLadda();
                return;
              } else {
                dataLogs["tours"] = [];
                if (
                  this.mData.dataDefault.ListKhachDuLichTable &&
                  this.mData.dataDefault.ListKhachDuLichTable.length > 0
                ) {
                  listTourist = this.fn_createArrayForLog(
                    this.mData.dataDefault.ListKhachDuLichTable,
                    "tourist"
                  );

                  if (listTourist.length > 0) {
                    let dataLogsTourist = MethodService.copyObject(dataLogs);
                    dataLogsTourist["type"] = "MessageToTourist";
                    dataLogsTourist["tos"] = listTourist;
                    const resTourist =
                      await mushroomDulich.notification_log.createAsync(
                        dataLogsTourist
                      );
                    logIdToTourist = resTourist.result;
                  }
                  this.mData.dataDefault.ListKhachDuLichTable.forEach(
                    async (item) => {
                      let dataPost = MethodService.copyObject(data);
                      dataPost.log_id = logIdToTourist;
                      dataPost.to = item.id;
                      dataPost.type = "MessageToTourist";
                      dataPost.group_type = "Services";
                      await mushroomDulich.notification.createAsync(dataPost);
                    }
                  );
                }
                if (
                  this.mData.dataDefault.ListHuongDanVienTable &&
                  this.mData.dataDefault.ListHuongDanVienTable.length > 0
                ) {
                  listTourguide = this.fn_createArrayForLog(
                    this.mData.dataDefault.ListHuongDanVienTable,
                    "tourguide"
                  );
                  if (listTourguide.length > 0) {
                    let dataLogsTourguide = MethodService.copyObject(dataLogs);
                    dataLogsTourguide["type"] = "MessageToTourGuide";
                    dataLogsTourguide["tos"] = listTourguide;
                    const resTourguide =
                      await mushroomDulich.notification_log.createAsync(
                        dataLogsTourguide
                      );
                    logIdToTourguide = resTourguide.result;
                  }
                  this.mData.dataDefault.ListHuongDanVienTable.forEach(
                    async (item) => {
                      let dataPost = MethodService.copyObject(data);
                      dataPost.log_id = logIdToTourguide;
                      dataPost.to = item.id;
                      dataPost.type = "MessageToTourGuide";
                      dataPost.group_type = "Services";
                      // data.target.targetId=$$cong_ty_lu_hanh_id;
                      await mushroomDulich.notification.createAsync(dataPost);
                    }
                  );
                }
              }
              this.fn_go(-1);
            }
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await mushroomDulich.notification.partialUpdateAsync(
              this.mData.dataForm
            );
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.mData.dataDefault.ListHuongDanVienTable = [];
      this.mData.dataDefault.ListKhachDuLichTable = [];
    },
    fn_go() {
      this.$router.push({ name: "Admin-" + this.mData.moduleName + "-list" });
    },
    async fn_getDataById(id) {
      let res = await mushroomDulich.notification_log.findByIdAsync({ id: id });
      this.mData.dataForm = res.result;
      if (!this.mData.dataForm.intro) {
        this.mData.dataForm.intro = "Chưa có thông tin";
      }
      if (!this.mData.dataForm.expiredTime) {
        this.haveExpiredTime = true;
        this.mData.dataForm.expiredTime = "Chưa có thông tin";
      }
      if (this.mData.dataForm.type == "MessageToTourist") {
        this.mData.dataForm.targetType = "people";
        this.mData.dataForm.tos.map((item) => {
          let info = item.to_name.replace("(tourist)", "").split("//");
          if (info.length > 0) {
            let data = {
              id: item.id,
              ho_ten: {
                ho_ten:
                  info[0] != "*" && info[0].trim() != ""
                    ? info[0]
                    : "Chưa có thông tin",
              },
              so_the: info[1] != "*" ? info[1] : "Chưa có thông tin",
              email:
                info[2] != "*" && info[2].trim() != ""
                  ? info[2]
                  : "Chưa có thông tin",
              dien_thoai: info[3] != "*" ? info[3] : "Chưa có thông tin",
              ngay_sinh: { ngay_sinh: info[4] != "*" ? info[4] : null },
              quoc_tich: {
                ten_quoc_tich: info[5] != "*" ? info[5] : "Chưa có thông tin",
              },
            };
            this.mData.dataDefault.ListKhachDuLichTable.push(data);
          }
        });
      } else if (this.mData.dataForm.type == "MessageToTourGuide") {
        this.mData.dataForm.targetType = "people";
        this.mData.dataForm.tos.map((item) => {
          let info = item.to_name.replace("(tourguide)", "").split("//");
          if (info.length > 0) {
            let data = {
              id: item.id,
              ho_ten: { ho_ten: info[0] != "*" ? info[0] : "" },
              the_hdv: { so_the: info[1] != "*" ? info[1] : "" },
              email: info[2] != "*" ? info[2] : "",
              dien_thoai: info[3] != "*" ? info[3] : "",
              ngay_sinh: { ngay_sinh: info[4] != "*" ? info[4] : null },
              quoc_tich: { ten_quoc_tich: info[5] != "*" ? info[5] : "" },
            };
            this.mData.dataDefault.ListHuongDanVienTable.push(data);
          }
        });
      } else if (this.mData.dataForm.type == "MessageToTourGuideAndTourist") {
        this.mData.dataForm.targetType = "people";
        this.mData.dataForm.tos.map((item) => {
          if (item.to_name.includes("(tourist)")) {
            let info = item.to_name.replace("(tourist)", "").split("//");
            if (info.length > 0) {
              let data = {
                id: item.id,
                ho_ten: { ho_ten: info[0] != "*" ? info[0] : "" },
                so_the: info[1] != "*" ? info[1] : "",
                email: info[2] != "*" ? info[2] : "",
                dien_thoai: info[3] != "*" ? info[3] : "",
                ngay_sinh: { ngay_sinh: info[4] != "*" ? info[4] : null },
                quoc_tich: { ten_quoc_tich: info[5] != "*" ? info[5] : "" },
              };
              this.mData.dataDefault.ListKhachDuLichTable.push(data);
            }
          } else {
            let info = item.to_name.replace("(tourguide)", "").split("//");
            if (info.length > 0) {
              let data = {
                id: item.id,
                ho_ten: { ho_ten: info[0] },
                the_hdv: { so_the: info[1] },
                email: info[2],
                dien_thoai: info[3],
                ngay_sinh: { ngay_sinh: info[4] },
                quoc_tich: { ten_quoc_tich: info[5] },
              };
              this.mData.dataDefault.ListHuongDanVienTable.push(data);
            }
          }
        });
      }
    },
    async fn_initDataDefault() {
      let currentUser = MethodService.getCurrentUser();
      if (MethodService.checkRole("Admin,Officer")) {
        this.mData.dataDefault.typeNotifi =
          ThongBaoModel.typeNotifiAdminOfficer;
        this.mData.dataDefault.showTour = false;
        delete this.mData.dataForm.targetType;
        delete this.mData.validForm.targetType;
      }
      if (MethodService.checkRole("TourAgent")) {
        this.mData.dataDefault.typeNotifi = ThongBaoModel.typeNotifiTourAgent;
        this.mData.dataDefault.typeNotifiByTour =
          ThongBaoModel.typeNotifiTourAgentByTour;
        this.mData.validForm = MethodService.copyObject(
          ThongBaoModel.validForm
        );
        this.mData.validForm.type = [];
        this.fn_checkDataDefaultByRole();
        this.mData.dataDefault.showTour = true;
      }
      if (this.mData.viewMode == "create") {
        this.mData.dataForm.from = currentUser.id;
      }
    },

    async fn_checkDataDefaultByRole() {
      let currentUser = MethodService.getCurrentUser();
      let res = await mushroomDulich.cong_ty_lu_hanh.listAsync({
        filters: "nguoi_quan_ly_ids=" + currentUser.id,
      });
      if (!res || !res.result || res.result.length == 0) {
        window.toastr.warning("Tài khoản chưa được thuộc công ty lữ hành nào");
      } else {
        this.mData.dataDefault.CongTyLuHanh = res.result[0];
        this.mData.dataForm.target.value = "cong_ty_lu_hanh.id";
        this.mData.dataForm.target.targetId =
          this.mData.dataDefault.CongTyLuHanh.id;
      }
    },

    fn_formatterDate(row, column, cellValue) {
      if (cellValue) {
        return MethodService.formatDate(cellValue, "date");
      } else {
        return "Chưa có thông tin";
      }
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    async fn_remoteGetListKhachDuLich(query) {
      this.mData.dataDefault.textFindKhachDuLich = query.trim();
      this.mData.dataDefault.ListKhachDuLich = [];
    },
    async fn_enterFindKhachDuLich() {
      // let filter= '';
      // if(this.mData.dataDefault.textFindKhachDuLich.substr(0,1)=="0"){
      //     filter = `so_the=${this.mData.dataDefault.textFindKhachDuLich}|so_the=${"84"+this.mData.dataDefault.textFindKhachDuLich.substring(1)}`
      //   let resKhachDuLichApi = await mushroomDulich.khach_du_lich.listAsync({
      //     limit: 1000,
      //     filters: filter
      //   });
      //   if (resKhachDuLichApi.result && resKhachDuLichApi.result.length > 0) {
      //     this.mData.dataDefault.ListKhachDuLich = resKhachDuLichApi.result;
      //   }
      // }
      if (this.mData.dataDefault.textFindKhachDuLich) {
        this.mData.dataDefault.textFindKhachDuLich =
          this.mData.dataDefault.textFindKhachDuLich.trim();
        let resKhachDuLichApi =
          await mushroomDulich.user.getUserIdOrFetchAcsUserAsync({
            body: { cardCode: this.mData.dataDefault.textFindKhachDuLich },
          });
        if (resKhachDuLichApi.result && resKhachDuLichApi.result.length > 0) {
          let khachDuLichApiResult =
            await mushroomDulich.khach_du_lich.findByIdAsync({
              id: resKhachDuLichApi.result,
            });
          this.mData.dataDefault.ListKhachDuLich.push(
            khachDuLichApiResult.result
          );
        }
      }

      // filter = `so_the=${this.mData.dataDefault.textFindKhachDuLich}`
      // let resKhachDuLichApi = await mushroomDulich.khach_du_lich.listAsync({
      //   limit: 1000,
      //   filters: filter,
      // });

      // if (resKhachDuLichApi.result && resKhachDuLichApi.result.length > 0) {
      //   this.mData.dataDefault.ListKhachDuLich = resKhachDuLichApi.result;
      // }
    },

    async fn_remoteGetListHuongDanVien(query) {
      this.mData.dataDefault.textFindHuongDanVien = query;
      this.mData.dataDefault.ListHuongDanVien = [];
    },
    async fn_enterFindHuongDanVien() {
      if (this.mData.dataDefault.textFindHuongDanVien) {
        this.mData.dataDefault.textFindHuongDanVien =
          this.mData.dataDefault.textFindHuongDanVien.trim();
        let resHuongDanVienApi = await mushroomDulich.huong_dan_vien.listAsync({
          limit: 1000,
          filters: `the_hdv.so_the=${this.mData.dataDefault.textFindHuongDanVien}`,
        });

        if (resHuongDanVienApi.result && resHuongDanVienApi.result.length > 0) {
          this.mData.dataDefault.ListHuongDanVien = resHuongDanVienApi.result;
          this.mData.dataDefault.ListHuongDanVien.forEach((item) => {
            if (item.gioi_tinh !== undefined || item.gioi_tinh === null) {
              let gt = DataService.gioiTinh.find(
                (element) => element.id == item.gioi_tinh
              );
              if (gt) {
                item.gioi_tinh = gt.text;
              }
            }
            if (item.ngay_sinh)
              item.ngay_sinh.ngay_sinh =
                ("0" + item.ngay_sinh.ngay).slice(-2) +
                "/" +
                ("0" + item.ngay_sinh.thang).slice(-2) +
                "/" +
                item.ngay_sinh.nam;
          });
        }
      }
    },

    fn_compareTime() {
      let timeStart = this.mData.dataForm.createdTime;
      let timeEnd = this.mData.dataForm.expiredTime;
      this.mData.dataDefault.validErrorTime = false;
      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() >= time2.getTime()) {
          this.mData.dataDefault.validErrorTime = true;
          return "TG bắt đầu phải nhỏ hơn TG kết thúc";
        } else {
          return "";
        }
      } else {
        this.mData.dataDefault.validErrorTime = true;
        return "Vui lòng nhập giá trị";
      }
    },
    fn_changeType(type) {
      this.mData.dataForm.to = null;
    },
    fn_changeTargetType(type) {
      this.mData.dataForm.type = null;
    },
    fn_addKhachDuLich(item) {
      if (item) {
        var flag = false;
        this.mData.dataDefault.ListKhachDuLichTable.forEach((element) => {
          if (item.id == element.id) {
            flag = true;
          }
        });
        if (flag) {
          window.toastr.info("Đã tồn tại Khách du lịch này");
        } else {
          if (item.id) {
            if (
              item.ho_ten &&
              item.ho_ten.ho_ten &&
              item.ho_ten.ho_ten.trim() != ""
            ) {
              item.ho_ten.ho_ten = item.ho_ten.ho_ten;
            } else {
              item.ho_ten = {
                ho_ten: "Chưa có thông tin",
              };
            }
            if (!item.email) {
              item.email = "Chưa có thông tin";
            }
            this.mData.dataDefault.ListKhachDuLichTable.push(item);
          }
        }

        this.mData.dataDefault.itemKhachDuLich = null;
        this.mData.dataDefault.ListKhachDuLich = [];
      }
    },

    fn_deleteKhachDuLich(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa bản ghi này không?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(() => {
          this.mData.dataDefault.ListKhachDuLichTable.splice(index, 1);
        })
        .catch(() => {});
    },
    fn_addHuongDanVien(item) {
      if (item) {
        var flag = false;
        this.mData.dataDefault.ListHuongDanVienTable.forEach((element) => {
          if (item.id == element.id) {
            flag = true;
          }
        });
        if (flag) {
          window.toastr.info("Đã tồn tại Hướng dẫn viên này");
        } else {
          if (item.id) {
            this.mData.dataDefault.ListHuongDanVienTable.push(item);
          }
        }

        this.mData.dataDefault.itemHuongDanVien = null;
        this.mData.dataDefault.ListHuongDanVien = [];
      }
    },

    fn_deleteHuongDanVien(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa bản ghi này không?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(() => {
          this.mData.dataDefault.ListHuongDanVienTable.splice(index, 1);
        })
        .catch(() => {});
    },
    async fn_addTour(item) {
      if (item) {
        if (item.id) {
          this.showAlertHaveNoTouristsOrTourGuide(
            item.khach_du_lich_ids || [],
            item.huong_dan_vien_ids || []
          );
          if (this.mData.dataForm.type == "MessageToTourist") {
            if (item.khach_du_lich_ids && item.khach_du_lich_ids.length > 0) {
              let resKhachDuLich = await mushroomDulich.khach_du_lich.listAsync(
                {
                  limit: item.khach_du_lich_ids.length,
                  filters: `id:in:${item.khach_du_lich_ids.join(",")}`,
                }
              );
              if (resKhachDuLich.result) {
                resKhachDuLich.result.forEach((kdl) => {
                  if (
                    !this.mData.dataDefault.ListKhachDuLichTable.find(
                      (kdlc) => kdlc.id == kdl.id
                    )
                  ) {
                    if (kdl.ngay_sinh)
                      kdl.ngay_sinh.ngay_sinh =
                        ("0" + kdl.ngay_sinh.ngay).slice(-2) +
                        "/" +
                        ("0" + kdl.ngay_sinh.thang).slice(-2) +
                        "/" +
                        kdl.ngay_sinh.nam;
                    this.mData.dataDefault.ListKhachDuLichTable.push(kdl);
                  }
                });
              }
            }
          }

          if (this.mData.dataForm.type == "MessageToTourGuide") {
            if (item.huong_dan_vien_ids && item.huong_dan_vien_ids.length > 0) {
              let resHuongDanVien =
                await mushroomDulich.huong_dan_vien.listAsync({
                  limit: item.huong_dan_vien_ids.length,
                  filters: `id:in:${item.huong_dan_vien_ids.join(",")}`,
                });
              if (resHuongDanVien.result) {
                resHuongDanVien.result.forEach((hdv) => {
                  if (
                    !this.mData.dataDefault.ListHuongDanVienTable.find(
                      (hdvc) => hdvc.id == hdv.id
                    )
                  ) {
                    if (hdv.ngay_sinh)
                      hdv.ngay_sinh.ngay_sinh =
                        ("0" + hdv.ngay_sinh.ngay).slice(-2) +
                        "/" +
                        ("0" + hdv.ngay_sinh.thang).slice(-2) +
                        "/" +
                        hdv.ngay_sinh.nam;
                    this.mData.dataDefault.ListHuongDanVienTable.push(hdv);
                  }
                });
              }
            }
          }

          if (this.mData.dataForm.type == "MessageToTourGuideAndTourist") {
            if (item.khach_du_lich_ids && item.khach_du_lich_ids.length > 0) {
              let resKhachDuLich = await mushroomDulich.khach_du_lich.listAsync(
                {
                  limit: item.khach_du_lich_ids.length,
                  filters: `id:in:${item.khach_du_lich_ids.join(",")}`,
                }
              );
              if (resKhachDuLich.result) {
                resKhachDuLich.result.forEach((kdl) => {
                  if (
                    !this.mData.dataDefault.ListKhachDuLichTable.find(
                      (kdlc) => kdlc.id == kdl.id
                    )
                  ) {
                    if (kdl.ngay_sinh)
                      kdl.ngay_sinh.ngay_sinh =
                        ("0" + kdl.ngay_sinh.ngay).slice(-2) +
                        "/" +
                        ("0" + kdl.ngay_sinh.thang).slice(-2) +
                        "/" +
                        kdl.ngay_sinh.nam;
                    this.mData.dataDefault.ListKhachDuLichTable.push(kdl);
                  }
                });
              }
            }
            if (item.huong_dan_vien_ids && item.huong_dan_vien_ids.length > 0) {
              let resHuongDanVien =
                await mushroomDulich.huong_dan_vien.listAsync({
                  limit: item.huong_dan_vien_ids.length,
                  filters: `id:in:${item.huong_dan_vien_ids.join(",")}`,
                });
              if (resHuongDanVien.result) {
                resHuongDanVien.result.forEach((hdv) => {
                  if (
                    !this.mData.dataDefault.ListHuongDanVienTable.find(
                      (hdvc) => hdvc.id == hdv.id
                    )
                  ) {
                    if (hdv.ngay_sinh)
                      hdv.ngay_sinh.ngay_sinh =
                        ("0" + hdv.ngay_sinh.ngay).slice(-2) +
                        "/" +
                        ("0" + hdv.ngay_sinh.thang).slice(-2) +
                        "/" +
                        hdv.ngay_sinh.nam;
                    this.mData.dataDefault.ListHuongDanVienTable.push(hdv);
                  }
                });
              }
            }
          }
        }

        this.mData.dataDefault.itemTour = null;
        this.mData.dataDefault.ListTour = [];
      }
    },
    showAlertHaveNoTouristsOrTourGuide(listTourists, listTourGuide) {
      if (
        this.mData.dataForm.type == "MessageToTourist" &&
        listTourists.length === 0
      ) {
        window.toastr.warning("Tour chưa có khách du lịch nào đã xác nhận");
      }
      if (
        this.mData.dataForm.type == "MessageToTourGuide" &&
        listTourGuide.length === 0
      ) {
        window.toastr.warning("Tour chưa có hướng dẫn viên nào đã xác nhận");
      }
      if (
        this.mData.dataForm.type == "MessageToTourGuideAndTourist" &&
        listTourists.length === 0 &&
        listTourGuide.length === 0
      ) {
        window.toastr.warning(
          "Tour chưa có khách du lịch và hướng dẫn viên nào đã xác nhận"
        );
      }
    },
    fn_deleteTour(index) {
      this.$confirm("Bạn có chắc chắn muốn xóa bản ghi này không?", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(() => {
          this.mData.dataDefault.ListTourTable.splice(index, 1);
        })
        .catch(() => {});
    },

    async fn_remoteGetListTour(query) {
      query = query.trim();
      if (query && query.length > 0) {
        let query1 = query
          .replace("*", "\\*")
          .replace("$", "\\$")
          .replace("%", "\\*")
          .replace("[", "\\[")
          .replace("]", "\\]")
          .replace("^", "\\^");
        if (this.mData.dataDefault.CongTyLuHanh) {
          let resTourApi = await mushroomDulich.tour.listAsync({
            limit: 1000,
            filters: `ten_tour:regex_i:${query1}`,
          });
          this.mData.dataDefault.ListTour = resTourApi.result;
        } else {
          let resTourApi = await mushroomDulich.tour.listAsync({
            limit: 1000,
            filters: `ten_tour:regex_i:${query1}`,
          });
          this.mData.dataDefault.ListTour = resTourApi.result;
        }
      }
    },

    fn_createArray(data, field) {
      let arrayNew = [];
      data.forEach((item) => {
        item[field].forEach((itemChild) => {
          if (arrayNew.includes(itemChild) == false) {
            arrayNew.push(itemChild);
          }
        });
      });
      return arrayNew;
    },

    fn_createArrayForLog(data, type) {
      let arrayNew = [];
      data.forEach((item) => {
        let data_logs = new Object();
        switch (type) {
          case "tour":
            data_logs = {
              tour_id: item.id,
              tour_name:
                (item.ten_tour ? item.ten_tour : "*") +
                "//" +
                (item.ten_doan ? item.ten_doan : "*") +
                "//" +
                (item.dia_diem.dia_diem ? item.dia_diem.dia_diem : "*") +
                "//" +
                (item.thoi_gian_bat_dau ? item.thoi_gian_bat_dau : "*") +
                "//" +
                (item.thoi_gian_ket_thuc ? item.thoi_gian_ket_thuc : "*"),
            };
            break;
          case "tourist":
            data_logs = {
              to_id: item.id,
              to_name:
                "(" +
                type +
                ")" +
                (item.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : "*") +
                "//" +
                (item.so_the ? item.so_the : "*") +
                "//" +
                (item.email ? item.email : "*") +
                "//" +
                (item.dien_thoai ? item.dien_thoai : "*") +
                "//" +
                (item.ngay_sinh && item.ngay_sinh.ngay_sinh
                  ? item.ngay_sinh.ngay_sinh
                  : "*") +
                "//" +
                (item.quoc_tich && item.quoc_tich.ten_quoc_tich
                  ? item.quoc_tich.ten_quoc_tich
                  : "*"),
            };
            break;
          case "tourguide":
            data_logs = {
              to_id: item.id,
              to_name:
                "(" +
                type +
                ")" +
                (item.ho_ten && item.ho_ten.ho_ten ? item.ho_ten.ho_ten : "*") +
                "//" +
                (item.the_hdv && item.the_hdv.so_the
                  ? item.the_hdv.so_the
                  : "*") +
                "//" +
                (item.email ? item.email : "*") +
                "//" +
                (item.dien_thoai ? item.dien_thoai : "*") +
                "//" +
                (item.ngay_sinh && item.ngay_sinh.ngay_sinh
                  ? item.ngay_sinh.ngay_sinh
                  : "*") +
                "//" +
                (item.quoc_tich && item.quoc_tich.ten_quoc_tich
                  ? item.quoc_tich.ten_quoc_tich
                  : "*"),
            };
            break;
        }
        arrayNew.push(data_logs);
      });
      return arrayNew;
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
      this.mData.dataDefault.typeNotifi = ThongBaoModel.typeNotifiType;
    }

    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>
<style lang="scss">
.el-select-dropdown__wrap {
  // max-width: 320px;
}
.el-autocomplete.inline-input {
  width: 100%;
}
</style>
